import profileRequest from '@stelecom/ui-react/components/requests/profileRequestIntegration';
import { captureQueryError, TResponse } from '~/src/api/helper';

export enum EIPv6Status {
    enabled = '1',
    disabled='2',
    error='3',
}

export interface IPv6State {
    status: EIPv6Status,
    subnet: string
}

export type TGetIPv6StatusResponse = TResponse<IPv6State, any>;


export async function getIPv6Status(domain: string, accessToken: string, terminalResource: number): Promise<TGetIPv6StatusResponse> {
    try {
        const resp = await profileRequest(domain, accessToken).post('/services-settings/get-ipv6-status', {
            trId: terminalResource,
        });
        const data = parseResponse(resp.data);
        return {
            isSuccess: true,
            payload: data,
        };
    } catch (e) {
        return captureQueryError(e);
    }
}

function parseResponse(data: any): IPv6State {
    return {
        status: data[0].status.value,
        subnet: data[0].subnet.value,
    };
}
